import {
	FETCH_ENCAISSEMENTSV2_BEGIN,
	FETCH_ENCAISSEMENTSV2_ERROR,
	FETCH_ENCAISSEMENTSV2_SUCCESS,
	DATER_ENCAISSEMENTSV2_BEGIN,
	DATER_ENCAISSEMENTSV2_ERROR,
	DATER_ENCAISSEMENTSV2_SUCCESS,
	DATER_ENCAISSEMENTSV2_RESET,
} from "../actions/encaissementsV2Actions"

const initialState = {
	transactions: [],
	fetchEncaissementsV2: {
		loading: false,
		error: false,
	},
	// Cycle de vie de la datation en masse (modal de confirmation) :
	// saving → saved (+ result {updated, skipped}) → reset à la fermeture.
	daterEncaissementsV2: {
		saving: false,
		saved: false,
		error: false,
		result: null,
	},
}

export default function encaissementsV2Reducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_ENCAISSEMENTSV2_BEGIN:
			return {
				...state,
				fetchEncaissementsV2: {
					loading: true,
					error: false,
				},
			}

		case FETCH_ENCAISSEMENTSV2_SUCCESS:
			return {
				...state,
				transactions: action.payload,
				fetchEncaissementsV2: {
					loading: false,
					error: false,
				},
			}

		case FETCH_ENCAISSEMENTSV2_ERROR:
			return {
				...state,
				fetchEncaissementsV2: {
					loading: false,
					error: action.payload,
				},
			}

		case DATER_ENCAISSEMENTSV2_BEGIN:
			return {
				...state,
				daterEncaissementsV2: {
					saving: true,
					saved: false,
					error: false,
					result: null,
				},
			}

		case DATER_ENCAISSEMENTSV2_SUCCESS:
			return {
				...state,
				daterEncaissementsV2: {
					saving: false,
					saved: true,
					error: false,
					result: action.payload,
				},
			}

		case DATER_ENCAISSEMENTSV2_ERROR:
			return {
				...state,
				daterEncaissementsV2: {
					saving: false,
					saved: false,
					error: action.payload,
					result: null,
				},
			}

		case DATER_ENCAISSEMENTSV2_RESET:
			return {
				...state,
				daterEncaissementsV2: initialState.daterEncaissementsV2,
			}

		default:
			return state
	}
}
